function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-c25a392a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./UpdateDetails.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./UpdateDetails.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c25a392a\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./UpdateDetails.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c25a392a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/donor/UpdateDetails.vue
// module id = 250
// module chunks = 0